(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anbernic-menu-backdrop')) {
    customElements.define('anbernic-menu-backdrop', class extends HTMLElement {
      connectedCallback() {
        this.onclick = () => this.parentElement.querySelector(':scope > summary')?.click();
        this.onpointerdown = event => event.preventDefault();
      }
      disconnectedCallback() {
        this.onclick = null;
        this.onpointerdown = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
